import type { AdminInspectorKycSummaryDto } from '@carcheck/shared';

/**
 * KYC manual-approve eligibility gate (AUT-125, architect guardrail 🟠 #1).
 *
 * The "Одобрить KYC" footer + KycTab CTA are gated on the *session* state,
 * NOT on the inspector FSM status. An inspector in `idcheck_pending` whose
 * latest session is not yet in `manual_review` cannot be approved — only a
 * provider-flagged `manual_review` session is in scope for the admin
 * override (the api will 409 `idcheck_session_not_in_manual_review`).
 *
 * Backend remains the sole 409 authority — this helper is pure UX so the
 * admin never fires a guaranteed-failure round-trip.
 */
export const canApproveKyc = (kyc: AdminInspectorKycSummaryDto): boolean =>
  kyc.sessionStatus === 'manual_review';
